/* jshint esversion: 6 */

import GtmService from '../gtm/gtm.service';

class CalcoloCFPCtrl {

	constructor(
		$scope,
		$location,
		$timeout,
		$http,
		StateService
	) {
		this.$scope = $scope;
		this.$location = $location;
		this.$timeout = $timeout;
		this.$http = $http;
		this.data = window.data || {};
		this.model = {};
		if (this.$location.search() && this.$location.search().email) {
			this.model.email = this.$location.search().email;
		}
		this.state = StateService.getState();
		this.state.ready();
	}

	setProvinces() {
		this.$timeout(() => {
			this.provinces = this.data.provinces.filter(x => x.countryId === this.model.Nazione);
		});
	}

	setColori() {
		this.$timeout(() => {
			
			var aa = this;
			this.colori = this.data.colors.filter(x => x.serie === this.model.Collezione)			
			//	console.log = "Colore " + this.model.Colore;
			this.model.Colore = null;
			this.spessorif = this.data.spessori.filter(x => x.colore === 0);
			this.formatif = this.data.formati.filter(x => x.colore === 0);
			this.finituref = this.data.finiture.filter(x => x.colore === 0);
			this.prodf = this.model.Collezione;
			this.nomeColl = aa.data.collections.filter(x => x.id == aa.model.Collezione)[0].name;
			this.model.Prodotto = this.nomeColl;
		});
	}
	setSpessori() {
		this.$timeout(() => {
			
			console.log = "2Colore " + this.model.Colore + " spessore" + this.model.Spessore	;

			this.nomeCol = this.data.colors.filter(x => x.id == this.model.Colore)[0].name;
			this.model.Spessore = null;
			
			this.spessorif = this.data.spessori.filter(x => x.colore === this.model.Colore );
			this.formatif = this.data.formati.filter(x => x.colore === 0);
			this.finituref = this.data.finiture.filter(x => x.colore === 0);
			this.model.Prodotto = this.nomeColl+ "-" + this.nomeCol;
		});
	}
	setFormati() {
		this.$timeout(() => {
			var aa = this;
			var oo = aa;
			this.nomeSp = this.data.spessori.filter(x => x.id == this.model.Spessore)[0].name;
			this.model.Formato= null;

			this.formatif = this.data.formati.filter(x => x.colore === this.model.Colore && x.spessore=== this.model.Spessore || x.colore==-1);
			this.finituref = this.data.finiture.filter(x => x.colore === 0);
			this.model.Prodotto = this.nomeColl + "-" + this.nomeCol + "-" + this.nomeSp;
		});
	}
	setFiniture() {
		this.$timeout(() => {
			this.nomeForm = this.data.formati.filter(x => x.id == this.model.Formato )[0].name;
			this.model.Finitura= null;
			this.finituref = this.data.finiture.filter(x => x.colore === this.model.Colore && x.spessore === this.model.Spessore && x.formato === this.model.Formato || x.colore == -1);
			this.model.Prodotto = this.nomeColl + "-" + this.nomeCol + "-" + this.nomeSp + "-" + this.nomeForm;

		});
	}
	setNomeFinitura() {
		this.$timeout(() => {
			this.nomeFin = this.data.finiture.filter(x => x.id == this.model.Finitura)[0].name;

			this.model.Prodotto = this.nomeColl + "-" + this.nomeCol + "-" + this.nomeSp + "-" + this.nomeForm+"-" + this.nomeFin;

		});
	}

	onSubmit() {
		var inputCaptcha = document.getElementById('g-recaptcha-response');
		if (inputCaptcha) {
			this.model.Captcha = inputCaptcha.value;
		} else {
			this.model.Captcha = '';
		}

		if (this.state.busy()) {
			this.$http.post('/WS/wsUsers.asmx/RichiestaCFP', { data: this.model }).then(
				success => {
					if (success.data.d.Status) {
						this.state.success();

						const obj = Object.assign({}, window.objDataLayerInfo);
						obj["eventname"] = "contact_us_cfp_request_sent";
						obj["label"] = "cfp_request";
						GtmService.push(obj);
					}
					else {
						this.state.error();
					}
				},
				error => {
					this.error = error;
				}
			);

			this.$timeout(() => {
				// this.state.ready();
			}, 2000);
		}
	}

	onInvalid() {
		this.$scope.$broadcast('onInvalid');
	}

}

CalcoloCFPCtrl.$inject = ['$scope', '$location', '$timeout', '$http', 'StateService'];

export default CalcoloCFPCtrl;
